import { render } from "./LanguageSwitch.vue?vue&type=template&id=196b34b1"
import script from "./LanguageSwitch.vue?vue&type=script&lang=js"
export * from "./LanguageSwitch.vue?vue&type=script&lang=js"

import "./LanguageSwitch.vue?vue&type=style&index=0&id=196b34b1&lang=css"

import exportComponent from "/tmp/build_642e477e/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__